import { Container } from '@/components';

export const ImprintPage = () => {
  return (
    <Container max={820}>
      <div className="ww-eyebrow" style={{ color: 'var(--ww-orange)' }}>
        Rechtliches
      </div>
      <h1 className="mb-8 mt-2 font-disp text-5xl uppercase text-ww-charcoal sm:text-6xl">
        IMPRESSUM
      </h1>
      <div className="ww-prose">
        <h2>Verantwortlich für Inhalt</h2>
        <p>Matthias Sondermann</p>
        <p>Wüst und Wild n.e.V., Wisbyer Str. 62, 10439 Berlin</p>
        <h2>Kontakt</h2>
        <p>
          E-Mail: info@wuest-und-wild.de
          <br />
          Website: wuest-und-wild.de
        </p>
      </div>
    </Container>
  );
};
